module.exports = __webpack_public_path__ + "static/media/residentialtech.5f106113.png";